import React from "react";
import { getUserDetails } from "config";
import { getFormattedNumber } from "utility/helpers";
import { StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";
import { UncontrolledTooltip } from "reactstrap";
import styled from "styled-components";
import { ACCOUNT_OTHERS } from "utility/constants";

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const dpwhColumns = ({ onEdit, onDelete }) => {
  const role = getUserDetails()?.type;

  const columns = [
    {
      name: "Project Allocation Title",
      selector: (row) => row.title || "",
      sortable: true,
      grow: 2,
      cell: (row) => (
        <p className="mb-0 wrap-text font-weight-bold">{row.title || "-"}</p>
      ),
    },
    {
      name: "Budget",
      selector: (row) => row.budget || 0,
      sortable: true,
      grow: 1,
      cell: (row) => (
        <p className="mb-0 wrap-text">{getFormattedNumber(row.budget || 0)}</p>
      ),
    },
    {
      name: "Notes",
      selector: (row) => row.notes || "",
      sortable: true,
      grow: 2,
      cell: (row) => <p className="mb-0 wrap-text">{row.notes || "-"}</p>,
    },
  ];

  // Only show Actions column for ACCOUNT_OTHERS role
  if (role === ACCOUNT_OTHERS) {
    columns.push({
      name: "Actions",
      selector: (row) => row.id,
      sortable: false,
      width: "120px",
      center: true,
      cell: (row, index) => (
        <ActionsContainer>
          {onEdit && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${row.id || index}`}
                onClick={() => onEdit(row)}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`edit-row--${row.id || index}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {onDelete && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${row.id || index}`}
                onClick={() => onDelete(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${row.id || index}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </ActionsContainer>
      ),
    });
  }

  return columns;
};

export default dpwhColumns;
